// extracted by mini-css-extract-plugin
export default {"navLink":"NavigationLink_navLink__pMXdk"};